import "./App.css";
import HomeOne from "./components/HomeOne";
import Services from "./components/Services";
import ServiceSingle from "./components/ServiceSingle";
import Blog from "./components/Blog";
import BlogDetails from "./components/BlogDetails";
import Team from "./components/Team";
import Shop from "./components/Shop";
import ShopSingle from "./components/ShopSingle";
import Cart from "./components/Cart";
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AboutUs from "./components/AboutUs";
import ContactUs from "./components/ContactUs";
import StoreLocation from "./components/StoreLocation";
import BlogDetails1 from "./components/BlogDetails1";
import BlogDetails2 from "./components/BlogDetails2";
import TermsConditions from "./components/policies/TermsConditions";
import PrivacyPolicy from "./components/policies/PrivacyPolicy";
import ReturnRefundPolicy from "./components/policies/ReturnRefundPolicy";
import WarrantyPolicy from "./components/policies/WarrantyPolicy";
import ServiceDetail from "./components/ServiceDetail";
import AreaPage from "./components/AreaPage";
import RepairQuote from "./components/RepairQuote";
import DeviceHealthCheck from "./components/DeviceHealthCheck";
import BusinessAccounts from "./components/BusinessAccounts";
import VipMembership from "./components/VipMembership";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomeOne />} />
        <Route path="/quote" element={<RepairQuote />} />
        <Route path="/device-health-check" element={<DeviceHealthCheck />} />
        <Route path="/business-accounts" element={<BusinessAccounts />} />
        <Route path="/vip" element={<VipMembership />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:slug" element={<ServiceDetail />} />
        <Route path="/areas/:slug" element={<AreaPage />} />
        <Route path="/service-single" element={<ServiceSingle />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog-details" element={<BlogDetails />} />
        <Route path="/blog-details1" element={<BlogDetails1 />} />
        <Route path="/blog-details2" element={<BlogDetails2 />} />
        <Route path="/team" element={<Team />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/shop-single" element={<ShopSingle />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/store-location" element={<StoreLocation />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/return-refund-policy" element={<ReturnRefundPolicy />} />
        <Route path="/warranty-policy" element={<WarrantyPolicy />} />
        {/* <Route path='/about' element={<About />} /> */}
      </Routes>
    </BrowserRouter>
  );
}

// function About() {
//   return <div>About Page</div>;
// }

export default App;
